import { UserLvl } from '@repo/types/enums/userLvl';
import { useParams } from 'react-router';

import GroupGradebook from '@/components/features/grades/GroupGradebook';
import StudentGroupGrades from '@/components/features/grades/StudentGroupGrades';
import { useCredentials } from '@/store/auth-store';

export default function GroupGradesPage() {
  const { id } = useParams();
  const groupId = id ? Number(id) : Number.NaN;
  const hasValidGroupId = Number.isFinite(groupId) && groupId > 0;

  const { id: userId, lvl } = useCredentials();

  if (!hasValidGroupId) {
    return <div className="text-muted-foreground flex h-full w-full items-center justify-center p-4">Nieprawidłowy identyfikator grupy.</div>;
  }

  if (lvl === UserLvl.STUDENT) {
    return <StudentGroupGrades groupId={groupId} userId={userId} />;
  }

  return <GroupGradebook groupId={groupId} />;
}
